import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import  TRANSLATIONS_FR  from "translations/fr/translation.json";
import  TRANSLATIONS_EN  from "translations/en/translation.json";


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: 'fr',
        keySeparator :'.',
        // lng: 'fr', // default language
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: TRANSLATIONS_EN
            },
            fr: {
                translation: TRANSLATIONS_FR
            }
        }

    }
    );


export default i18n;


